import * as React from "react";
import {Input as BSInput} from 'reactstrap';

export class Textarea extends React.Component<any> {
    render() {
        const { name, id, value, placeholder, rows = 3, onChange, onKeyPress, disabled = false, invalid = false } = this.props;
        return (
            <BSInput
                type="textarea"
                placeholder={placeholder}
                onChange={(e: any) => onChange(e.target.value, e)}
                onKeyPress={onKeyPress}
                value={value || ""}
                name={name}
                id={id || name}
                disabled={disabled}
                invalid={invalid}
                rows={rows}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/fields/Textarea.tsx